import {memo, useContext} from 'react'
import {DiagramConfigContext} from "../../context/DiagramConfigContext.tsx";

export type DiagramLinkProps = {
    id: string,
    path: string,
    halfWidth: number,
    reversePath?: string,
    color: string,
    onClick: () => void,
    opacity: string | number,
    amount: number,
    selected?: boolean
}
export const DiagramLink =
    memo(({
        id,
        path,
        halfWidth,
        color,
        onClick,
        opacity,
        selected
    }: DiagramLinkProps) => {
        const { config } = useContext(DiagramConfigContext)

        const selectedStyle = config.selected

        return (<g
            onClick={onClick}
            style={{
                cursor: 'pointer',
                filter: selected ? selectedStyle.filter : undefined,
            }}
        >
            <path
                id={id}
                d={path}
                stroke={selected ? selectedStyle.color : color}
                fill="none"
                strokeWidth={halfWidth}
                strokeOpacity={selected ? 1 : opacity}
            />
            <path
                id={id}
                d={path}
                stroke='#91CAFF'
                fill="none"
                strokeOpacity={selected ? 1 : opacity}
            />
        </g>)
    })
